import React from 'react';
import {useParams} from 'react-router';
import {useTariff} from 'contexts/Tariff';
import Checkmark from 'components/ui/icon/Checkmark';
import Price from 'components/ui/Price';

import './SupplementTile.scss';

const SupplementTile = ({supplement}) => {
  const tariffAPI = useTariff();
  const {slug} = useParams();
  const isChosen = tariffAPI.checkIsChosen(supplement, slug);

  return (
    <div className="supplement-tile">
      <p className="supplement-tile__name">{supplement.name}</p>
      <div className="supplement-tile__footer">
        <Price
          amount={supplement.price}
          unit={supplement.unit}
          extraClassName="supplement-tile__price"
        />

        {!isChosen && (
          <button
            className="supplement-tile__button supplement-tile__button_add"
            onClick={() => tariffAPI.addSupplement(supplement, slug)}
          >
            +
          </button>
        )}
        {isChosen && (
          <button
            onClick={() => tariffAPI.removeSupplement(supplement, slug)}
            className="supplement-tile__button supplement-tile__button_remove"
          >
            <span>Выбрано</span>
            <Checkmark color="#000" />
          </button>
        )}
      </div>
    </div>
  );
};

export default SupplementTile;
